var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlugIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H98C100.209 0 102 1.79086 102 4V98C102 100.209 100.209 102 98 102H4C1.79086 102 0 100.209 0 98V4Z",
    fill: "#F8F9FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79 25.828L76.172 23L23 76.172L25.828 79L29.828 75H71C72.0604 74.9984 73.0769 74.5765 73.8267 73.8267C74.5765 73.0769 74.9984 72.0604 75 71V29.828L79 25.828ZM71 71H33.828L49.414 55.414L54.172 60.172C54.9221 60.9219 55.9393 61.3431 57 61.3431C58.0607 61.3431 59.0779 60.9219 59.828 60.172L63 57L71 64.994V71ZM71 59.336L65.828 54.164C65.0779 53.4141 64.0607 52.9929 63 52.9929C61.9393 52.9929 60.9221 53.4141 60.172 54.164L57 57.336L52.246 52.582L71 33.828V59.336ZM31 63V57L41 47.006L43.746 49.754L46.578 46.922L43.828 44.172C43.0779 43.4221 42.0607 43.0009 41 43.0009C39.9393 43.0009 38.9221 43.4221 38.172 44.172L31 51.344V31H63V27H31C29.9395 27.0011 28.9227 27.4228 28.1727 28.1727C27.4228 28.9227 27.0011 29.9395 27 31V63H31Z",
    fill: "#C5CCD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugIcon);
export default __webpack_public_path__ + "static/media/plug_icon.32d6feb90d54136e3cfeda745103b967.svg";
export { ForwardRef as ReactComponent };